import { Form } from './form'
import { Onboarding } from './onboarding'

export const CommonClient = {
  Form,
  Onboarding,
}

export * from './types'
